const constructGetAbortController = <TSearchStates, TKey extends keyof TSearchStates>() => {
  const controllers = new Map<TKey, AbortController>();

  return (key: TKey) => {
    if (controllers.has(key)) {
      controllers.get(key).abort();
    }

    const controller = new AbortController();
    controllers.set(key, controller);

    return controller;
  };
};

export default constructGetAbortController;
